class EstimateShipping extends HTMLElement {
  constructor() {
    super();
    this.initShippingCalc = this.initShippingCalc.bind(this);
    this.generateShippingRates = this.generateShippingRates.bind(this);
  }

  connectedCallback() {
    this.initShippingCalc();
    this.addEventListeners();
  }

  // Libellés fournis par Liquid via data-* (le JS est un asset statique, il n'a pas accès aux traductions)
  get labels() {
    return {
      none: this.dataset.i18nNone || 'Nous ne livrons pas encore vers cette destination.',
      free: this.dataset.i18nFree || 'Offerte',
      error: this.dataset.i18nError || 'Vérifiez le pays et le code postal saisis.'
    };
  }

  formatPrice(price, currency) {
    const value = parseFloat(price);
    if (!isFinite(value)) return price;
    if (value === 0) return this.labels.free;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: currency
      }).format(value);
    } catch (e) {
      return `${value.toFixed(2)} ${currency}`;
    }
  }

  async initShippingCalc() {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    const cartFooter = document.querySelector('.cart__footer');

    new Shopify.CountryProvinceSelector('es-shipping-calc-country', 'es-shipping-calc-province', {
      hideElement: 'es-shipping-calc-province-wrapper'
    });

    if (cartDrawerItems && !cartDrawerItems.classList.contains('is-empty')) {
      const el = document.querySelector('#CartDrawer #es-shipping-calc');
      if (el) el.style.display = 'block';
    }
    if (cartFooter) {
      const el = document.querySelector('#MainContent #es-shipping-calc');
      if (el) el.style.display = 'block';
    }
  }

  addEventListeners() {
    const selectAllshippingCountry = this.querySelectorAll('#es-shipping-calc-country');
    let selectedValue;

    selectAllshippingCountry.forEach((selectElement) => {
      selectElement.addEventListener('change', (event) => {
        selectedValue = event.target.selectedOptions[0];
        selectAllshippingCountry.forEach((element) => {
          const optionToSelect = Array.from(element.options).find(
            (option) => option.value === selectedValue.value
          );
          if (!optionToSelect) return;
          optionToSelect.selected = true;
          const dataProvinces = selectedValue.getAttribute('data-provinces');
          if (!dataProvinces) return;
          const allProvinceWrappers = this.querySelectorAll('#es-shipping-calc-province-wrapper');
          const hasProvinces = dataProvinces.split(' ').length > 1;
          allProvinceWrappers.forEach((wrapper) => {
            wrapper.style.display = hasProvinces ? 'block' : 'none';
          });
        });
        new Shopify.CountryProvinceSelector('es-shipping-calc-country', 'es-shipping-calc-province', {
          hideElement: 'es-shipping-calc-province-wrapper'
        });
      });
    });

    const generateShippingRatesButton = this.querySelector('#es-shipping-calc-btn');
    if (generateShippingRatesButton) {
      generateShippingRatesButton.addEventListener('click', (event) => {
        this.generateShippingRates(event.currentTarget);
      });
    }
  }

  async generateShippingRates(btn) {
    const loadingSpinner = btn.querySelector('.loading__spinner');
    const wrapper = btn.closest('estimate-shipping');
    const alertDanger = wrapper.querySelector('#es-shipping-calc-alert-danger');
    const alertWarning = wrapper.querySelector('#es-shipping-calc-alert-warning');
    const alertSuccess = wrapper.querySelector('#es-shipping-calc-alert-success');

    const reset = (el) => {
      el.innerHTML = '';
      el.setAttribute('hidden', 'hidden');
    };
    const show = (el, html) => {
      el.innerHTML = html;
      el.removeAttribute('hidden');
    };

    btn.classList.add('loading');
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
    [alertDanger, alertWarning, alertSuccess].forEach(reset);

    try {
      const country = wrapper.querySelector('#es-shipping-calc-country').value;
      const province = wrapper.querySelector('#es-shipping-calc-province').value;
      const zip = wrapper.querySelector('#es-shipping-calc-zip').value;
      const query =
        `shipping_address[zip]=${encodeURIComponent(zip)}` +
        `&shipping_address[country]=${encodeURIComponent(country)}` +
        `&shipping_address[province]=${encodeURIComponent(province)}`;

      const prepareResponse = await fetch(`${window.Shopify.routes.root}cart/prepare_shipping_rates.json?${query}`, {
        method: 'POST'
      });

      if (!prepareResponse.ok) {
        // Shopify renvoie {champ: ["message"]} — on n'affiche que les messages, jamais les noms de champs
        let messages = [];
        try {
          const data = await prepareResponse.json();
          messages = Object.values(data).flat().filter(Boolean);
        } catch (e) {
          /* corps illisible : on retombe sur le message générique */
        }
        show(alertDanger, `<p>${messages.length ? messages.join(' ') : this.labels.error}</p>`);
        return;
      }

      const ratesResponse = await fetch(`${window.Shopify.routes.root}cart/async_shipping_rates.json?${query}`);
      const data = await ratesResponse.json();
      const rates = (data && Array.isArray(data.shipping_rates)) ? data.shipping_rates : [];

      if (!rates.length) {
        show(alertWarning, `<p>${this.labels.none}</p>`);
        return;
      }

      const items = rates
        .map((rate) => `<li>${rate.presentment_name} : <strong>${this.formatPrice(rate.price, rate.currency)}</strong></li>`)
        .join('');
      show(alertSuccess, `<ul>${items}</ul>`);
    } catch (error) {
      show(alertDanger, `<p>${this.labels.error}</p>`);
    } finally {
      btn.classList.remove('loading');
      if (loadingSpinner) loadingSpinner.classList.add('hidden');
    }
  }
}

customElements.define('estimate-shipping', EstimateShipping);
